export default __webpack_public_path__ + "static/media/walrus2.765e57ea.png";